import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { promptApi } from "../../../api/prompt";

export const promptKeys = {
  all: () => ["prompts"],
  allAdmin: () => ["prompts", "admin"],
  filtered: (filters) => ["prompts", "filtered", filters],
};

export function useGetPrompts(config) {
  const { callApi } = useAuth();
  return useQuery(
    promptKeys.all(),
    () => callApi(promptApi.getPrompts),
    config
  );
}

export function useGetFilteredPrompts(filters, config) {
  const { callApi } = useAuth();
  return useQuery(
    promptKeys.filtered(filters),
    () => callApi(promptApi.getFilteredPrompts, filters),
    { enabled: !!filters, ...config }
  );
}

export function useGetAllPrompts(config) {
  const { callApi } = useAuth();
  return useQuery(
    promptKeys.allAdmin(),
    () => callApi(promptApi.getAllPrompts),
    config
  );
}

export function useCreatePrompt(config) {
  const { callApi } = useAuth();
  return useMutation(
    (data) => callApi(promptApi.createPrompt, data),
    config
  );
}

export function useUpdatePrompt(config) {
  const { callApi } = useAuth();
  return useMutation(
    ({ id, data }) => callApi(promptApi.updatePrompt, { id, data }),
    config
  );
}

export function useDeletePrompt(config) {
  const { callApi } = useAuth();
  return useMutation(
    (id) => callApi(promptApi.deletePrompt, id),
    config
  );
}
